import React from 'react';
import Icon from '../../../components/AppIcon';

const ScriptTypeSelector = ({ selectedType, onTypeChange }) => {
  const scriptTypes = [
    {
      id: 'sms',
      name: 'SMS',
      icon: 'MessageSquare',
      description: 'Quick text message scripts for immediate engagement',
      maxLength: '160 characters',
      bestFor: 'Quick follow-ups, appointment reminders'
    },
    {
      id: 'email',
      name: 'Email',
      icon: 'Mail',
      description: 'Professional email templates with structure',
      maxLength: 'Detailed format',
      bestFor: 'Proposals, detailed information, follow-ups'
    },
    {
      id: 'call_script',
      name: 'Call Script',
      icon: 'Phone',
      description: 'Conversation flow with objection handling',
      maxLength: 'Full dialogue',
      bestFor: 'Discovery calls, closing conversations'
    }
  ];

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold text-foreground">Select Script Type</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {scriptTypes?.map((type) => (
          <button
            key={type?.id}
            onClick={() => onTypeChange(type?.id)}
            className={`p-4 rounded-xl border-2 transition-all duration-200 text-left ${
              selectedType === type?.id
                ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/50'
            }`}
          >
            <div className="flex items-start gap-3 mb-3">
              <div
                className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                  selectedType === type?.id ? 'bg-primary' : 'bg-muted'
                }`}
              >
                <Icon
                  name={type?.icon}
                  size={20}
                  color={selectedType === type?.id ? '#FFFFFF' : 'var(--color-muted-foreground)'}
                />
              </div>
              <div className="flex-1">
                <h4 className="text-base font-semibold text-foreground mb-1">{type?.name}</h4>
                <p className="text-xs text-muted-foreground">{type?.description}</p>
              </div>
            </div>
            <div className="space-y-1">
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Icon name="FileText" size={14} />
                <span>{type?.maxLength}</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Icon name="Target" size={14} />
                <span>{type?.bestFor}</span>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ScriptTypeSelector;